import React from 'react';

export const GoogleIcon = (): JSX.Element => (
  <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15.68 8.18128C15.68 7.61401 15.6291 7.06856 15.5345 6.54492H8V9.63947H12.3055C12.12 10.6395 11.5564 11.4867 10.7091 12.054V14.0613H13.2945C14.8073 12.6686 15.68 10.6176 15.68 8.18128Z'
      fill='#4285F4'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.99992 15.9995C10.1599 15.9995 11.9708 15.2832 13.2945 14.0613L10.709 12.0541C9.99265 12.5341 9.07628 12.8177 7.99992 12.8177C5.91628 12.8177 4.15265 11.4104 3.52356 9.51953H0.85083V11.5923C2.16719 14.2068 4.87265 15.9995 7.99992 15.9995Z'
      fill='#34A853'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.52364 9.51995C3.36364 9.03995 3.27273 8.52723 3.27273 7.99995C3.27273 7.47268 3.36364 6.95995 3.52364 6.47995V4.40723H0.850909C0.309091 5.48723 0 6.70904 0 7.99995C0 9.29086 0.309091 10.5127 0.850909 11.5927L3.52364 9.51995Z'
      fill='#FBBC05'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.99992 3.18182C9.17447 3.18182 10.229 3.58545 11.0581 4.37818L13.3526 2.08364C11.9672 0.792727 10.1563 0 7.99992 0C4.87265 0 2.16719 1.79273 0.85083 4.40727L3.52356 6.48C4.15265 4.58909 5.91629 3.18182 7.99992 3.18182Z'
      fill='#EA4335'
    />
  </svg>
);

export const AppleIcon = (): JSX.Element => (
  <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
    <path
      d='M14.1879 12.2833C13.956 12.819 13.6815 13.3121 13.3635 13.7655C12.93 14.3835 12.5751 14.8113 12.3015 15.0489C11.8775 15.4388 11.4232 15.6385 10.9367 15.6499C10.5875 15.6499 10.1663 15.5505 9.67601 15.3489C9.18413 15.1483 8.7321 15.0489 8.31877 15.0489C7.88529 15.0489 7.42038 15.1483 6.9231 15.3489C6.42507 15.5505 6.02386 15.6556 5.71710 15.666C5.25059 15.6859 4.78559 15.4805 4.32144 15.0489C4.02519 14.7905 3.65465 14.3476 3.21075 13.72C2.73448 13.0499 2.34293 12.2729 2.03618 11.387C1.70766 10.4301 1.54297 9.50351 1.54297 8.60644C1.54297 7.57886 1.76501 6.69258 2.20976 5.94988C2.55929 5.35332 3.02429 4.88273 3.60628 4.53727C4.18827 4.19181 4.81710 4.01577 5.49431 4.0045C5.86485 4.0045 6.35077 4.11912 6.95462 4.34438C7.55677 4.5704 7.94340 4.68502 8.11291 4.68502C8.23965 4.68502 8.66916 4.551 9.39728 4.28381C10.0858 4.03602 10.6670 3.93342 11.1430 3.97384C12.4331 4.07795 13.4023 4.58649 14.0468 5.50267C12.8931 6.20174 12.3224 7.18086 12.3337 8.43693C12.3441 9.4153 12.6990 10.2295 13.3966 10.8759C13.7127 11.1759 14.0658 11.4078 14.4585 11.5725C14.3734 11.8195 14.2834 12.0561 14.1879 12.2833ZM11.2292 0.640738C11.2292 1.40758 10.9490 2.12358 10.3906 2.7863C9.71671 3.57414 8.90161 4.02939 8.01770 3.95756C8.00643 3.86556 7.99990 3.76874 7.99990 3.66699C7.99990 2.93082 8.32038 2.14298 8.88949 1.49881C9.17362 1.17266 9.53499 0.901463 9.97321 0.685127C10.4105 0.472019 10.8241 0.354166 11.2131 0.333984C11.2244 0.436499 11.2292 0.539020 11.2292 0.640728V0.640738Z'
      fill='#2C3236'
    />
  </svg>
);
